import { isUndNullEmp } from '../../helpers/main.js';

export class StatementAccountByCompany {
    constructor(
        _cRifEmpresa = '',
        _cCodEmpresa = '',
        _cNomEmpresa = '',
        _total_Art = 0,
        _total_Art_Saldo = 0,
        _netAmountDocument = 0,
        _balanceDocument = 0,
        _netAmountDeliveryNote = 0,
        _balanceDeliveryNote = 0,
    ) {
        this.cRifEmpresa = _cRifEmpresa;
        this.cCodEmpresa = _cCodEmpresa;
        this.cNomEmpresa = _cNomEmpresa;
        this.total_Art = _total_Art;
        this.total_Art_Saldo = _total_Art_Saldo;
        this.netAmountDocument = _netAmountDocument;
        this.balanceDocument = _balanceDocument;
        this.netAmountDeliveryNote = _netAmountDeliveryNote;
        this.balanceDeliveryNote = _balanceDeliveryNote;
    }

    static getClassName = () => {
        return 'StatementAccountByCompany - class';
    }

    //#region old code
    // static minMaxLength = (upperCase = false) => {
    //     if (upperCase) {
    //         return {
    //             min: {
    //                 CompanyId: 0,
    //                 CustomerId: 0,
    //             },
    //             max: {
    //                 CompanyId: 254,
    //                 CustomerId: 254,
    //             }
    //         };
    //     } else {
    //         return {
    //             min: {
    //                 companyId: 0,
    //                 customerId: 0,
    //             },
    //             max: {
    //                 companyId: 0,
    //                 customerId: 30,
    //             }
    //         };
    //     }
    // }
    //#endregion old code

    static class = (obj = {}, upperCase = false) => {
        if (!isUndNullEmp({ data: obj, subMethod: this.getClassName() })?.result) {
            if (upperCase) {
                return new StatementAccountByCompany(
                    obj.cRifEmpresa,
                    obj.cCodEmpresa,
                    obj.cNomEmpresa,
                    obj.TOTAL_ART,
                    obj.TOTAL_ART_SALDO,
                    obj.NetAmountDocument,
                    obj.BalanceDocument,
                    obj.NetAmountDeliveryNote,
                    obj.BalanceDeliveryNote,
                );
            } else {
                return new StatementAccountByCompany(
                    obj.cRifEmpresa,
                    obj.cCodEmpresa,
                    obj.cNomEmpresa,
                    obj.total_Art,
                    obj.total_Art_Saldo,
                    obj.netAmountDocument,
                    obj.balanceDocument,
                    obj.netAmountDeliveryNote,
                    obj.balanceDeliveryNote,
                );
            }
        } else {
            return new StatementAccountByCompany();
        }
    }
}